import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchFutureActions } from './store/slice';
import { actions as futureActionsActions } from './store/slice';
import { showModal } from 'Core/redux/main/slice';
import { showToast } from 'Core/redux/toast/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { MoldService } from '../../service/api/mold-service';
import FutureActionsModals from './future-actions-modals';
import FutureActionsContent from './future-actions-content';
import FutureActionsTopHead from './future-actions-top-head';
import {
  parseFutureActionsDeepLink,
  normalizeFutureActionMold,
} from './future-actions-deep-link';
const { resetFilters } = futureActionsActions;
const { FUTUREACTIONS_DETAILS } = MODAL_TYPES;

const FutureActionsView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);

  useEffect(() => {
    dispatch(fetchFutureActions());
    return () => dispatch(resetFilters());
  }, []);

  useEffect(() => {
    const deepLink = parseFutureActionsDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = `${deepLink.moldInfoId}:${deepLink.futureActionId || ''}`;
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }

    let cancelled = false;
    (async () => {
      let mold = {
        moldInfoID: deepLink.moldInfoId,
        focusedFutureActionId: deepLink.futureActionId,
      };
      try {
        const response = await MoldService.getMoldById(deepLink.moldInfoId);
        if (response.status === 200 && response.response) {
          const normalized = normalizeFutureActionMold(response.response);
          mold = {
            ...normalized,
            moldInfoID: normalized?.moldInfoID || deepLink.moldInfoId,
            focusedFutureActionId: deepLink.futureActionId,
          };
        }
      } catch {
        // Open with ids from the notification if mold lookup fails.
      }

      if (cancelled) {
        return;
      }
      if (!mold.moldInfoID) {
        dispatch(
          showToast({
            message: 'Could not open the future action from this notification.',
            type: 'danger',
          }),
        );
        return;
      }

      dispatch(showModal(FUTUREACTIONS_DETAILS, mold));
      openedDeepLinkKeyRef.current = key;
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, location.search]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Future Actions</h4>
              </div>
            </div>
            <FutureActionsTopHead />
          </div>
          <FutureActionsContent />
          <FutureActionsModals />
        </div>
      </div>
    </div>
  );
};

export default FutureActionsView;
